<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    :initialFilters="filters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="2" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="1" class="text-left title"><strong>{{ this.fieldsTotalArea | formatNumber }} ha</strong></td>
        <td colspan="4" class="text-left title"><strong>{{ this.fieldsTotalUsefulArea | formatNumber }} ha</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Área Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.fieldsTotalArea | formatNumber }} ha</strong></div>
        </td>
      </tr>

      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Área Útil Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.fieldsTotalUsefulArea | formatNumber }} ha</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      fieldsTotalArea: 0,
      fieldsTotalUsefulArea: 0,
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Nome", align: "left", sortable: true, value: "name" },
        { text: "Área Total", align: "left", sortable: true, value: "area" },
        { text: "Área Útil", align: "left", sortable: true, value: "usefulArea" },
        { text: "Descrição", align: "left", sortable: true, value: "description" },
        { text: "Ativo", align: "left", sortable: true, value: "enabled" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'area', mask: 'number_unit', unit: 'ha'},
        { field: 'usefulArea', mask: 'number_unit', unit: 'ha'},
        {field: "enabled", mask: "nice_boolean"},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [{
        field: "enabled",
        fieldValues: [true],
        key: 0,
        operator: "in",
        type: "boolean"
      }], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Talhão"
    },
    modelNamePlural: {
      type: String,
      default: "Talhões"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_FIELDS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.fields = response.data.groundContext.fieldsIndex.fields;
          //console.log("All fields", this.fields);
          this.indexItems = response.data.groundContext.fieldsIndex.fieldViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.groundContext.fieldsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.groundContext.fieldsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.groundContext.fieldsIndex.serverFields; // seta os campos que podem ser filtrados

          this.fieldsTotalArea = 0;
          this.fieldsTotalUsefulArea = 0;
          for (var field in this.indexItems) {
            this.fieldsTotalArea += this.indexItems[field].area;
            this.fieldsTotalUsefulArea += this.indexItems[field].usefulArea;
          }
          this.fieldsTotalArea = _.round(this.fieldsTotalArea, 2);
          this.fieldsTotalUsefulArea = _.round(this.fieldsTotalUsefulArea, 2);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_FIELDS = gql `
  query($input: IndexInputObject!) {
    groundContext {
      fieldsIndex(input: $input){
        count
        typeOperators
        serverFields      
        fieldViewIndexFilters {
          id
          code
          name
          area
          enabled
          usefulArea
          description
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
